<template>
  <div id="obch-prip-wrapped">
    <pripady-filter
      ref="pripadyFilter"
      @filter="filter => $refs.table.loadData(filter)"
    ></pripady-filter>
    <pripady-table ref="table" @reloadTable="() => $refs.pripadyFilter.applyFilter()"></pripady-table>
    <v-container class="pripady-table"></v-container>
  </div>
</template>
<script>
import PripadyFilter from '../components/table_pripady/PripadyFilter.vue';
import PripadyTable from '../components/table_pripady/PripadyTable.vue';
export default {
  components: {
    PripadyFilter,
    PripadyTable,
  },
  data() {
    return {};
  },
};
</script>
<style lang="sass">
.obch-prip-wrapped
  z-index: 2 !important
</style>
